/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ApolloProvider } from "@apollo/client";
import client from "./utils/init-appSync";
import suggesticClient from "./utils/suggesticClient";

/**
 * This component is used for called App.tsx.
 *
 */

ReactDOM.render(
  <ApolloProvider client={client as any}>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <React.StrictMode>
          <App client={client} suggesticClient={suggesticClient} />
        </React.StrictMode>
      </BrowserRouter>
    </I18nextProvider>
  </ApolloProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
